<template>
  <!-- 谷歌地图 | 天地图 -->
  <div>
    <el-table v-loading.body="listLoading" :data="titleList" border element-loading-text="Loading" fit highlight-current-row>
      <el-table-column :label="$t('location.device')" align="center">
        <template slot-scope="scope" align="left">
          <span>{{ scope.row.deviceName }}</span>
          <br>
          <span>{{ scope.row.mcuId }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('yhubReport.StartingTime')" align="center">
        <template slot-scope="scope">
          <el-date-picker v-model="listQuery.startTime" :clearable="false" :placeholder="$t('yhubReport.StartingTime')" size="mini" type="datetime" value-format="timestamp" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('yhubReport.EndTime')" align="center">
        <template slot-scope="scope">
          <el-date-picker v-model="listQuery.endTime" :clearable="false" :placeholder="$t('yhubReport.EndTime')" size="mini" type="datetime" value-format="timestamp" />
        </template>
      </el-table-column>

      <el-table-column align="center" label>
        <template slot-scope="scope">
          <el-button class="filter-item" icon="el-icon-search" type="primary" :disabled="isDisabeldSearchBtn" @click="init" />
        </template>
      </el-table-column>
    </el-table>

    <el-container>
      <el-main style="position: relative;background: #fff;padding: 0;margin: 20px 0;">
        <!-- <div style="width: 100%;height: 30px;background: white">
          <el-switch
            v-model="mapShow"
            style="display: block;position: absolute;float: bottom;padding-top: 5px;padding-left: 5px"
            active-color="#13ce66"
            inactive-color="#56BEDB"
            active-text="高德地图"
            inactive-text="GoogleMap"
          />
        </div>-->
        <div style="width: 100%;height: 40px;background: white">
          <div align="right" class="input-item">
            <el-button class="filter-item" icon="el-icon-start" type="primary" @click="startAnimation('start')">{{ $t('location.start') }}</el-button>
            <el-button class="filter-item" icon="el-icon-pause" type="primary" @click="pauseAnimation('pause')">{{ $t('location.pause') }}</el-button>
            <el-button class="filter-item" icon="el-icon-resume" type="primary" @click="resumeAnimation('resume')">{{ $t('location.contiune') }}</el-button>
            <el-button class="filter-item" icon="el-icon-stop" type="primary" @click="stopAnimation('stop')">{{ $t('location.stop') }}</el-button>
          </div>
        </div>
        <div v-show="mapShow" id="map-container" v-loading="loading" />
        <gmap-map v-show="!mapShow" id="gmap-container" v-loading="loading" :center="center" :zoom="12" />
      </el-main>
    </el-container>

    <el-table v-loading.body="loading" :data="datatable" border element-loading-text="Loading" fit highlight-current-row>
      <el-table-column type="index" width="100" />
      <el-table-column :label="$t('dashboard.LatestUpdate')" align="center">
        <template slot-scope="scope">
          <span>{{ new Date(scope.row.yhubStime) }}</span>
          <!--<span>{{scope.row.createTime}}</span>-->
        </template>
      </el-table-column>
      <el-table-column :label="$t('location.longitude')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.gnssLong }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('location.latitude')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.gnssLat }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- <el-dialog :visible.sync="dialogVisible" title="温馨提示" width="30%">
      <span>没有找到记录信息，请选择其它设备或重新设置起止时间。</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import { listLocationData } from '@/api/locationManagement'
import apiproto from '@/proto/apiproto'
import protobuf from 'protobufjs'
import iconCharging from '@/assets/icon/map_icon_online_charging.png'
import iconyhub from '@/assets/icon/map_icon_online.png'
import iconwarr from '@/assets/icon/map_icon_online_warning.png'
import iconoffline from '@/assets/icon/map_icon_offline.png'
import { loadTiandiJs } from '@/components/tianMap/asyncLoadJs'
import { tianMapLngLat } from '@/utils/transformLatLng'
import i18n from '@/i18n'
const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')
var marker
var traceList = []
var timer = null
var count = 0
var hadClickBtn, hadCount, line
// 定义一些常量
var PI = 3.1415926535897932384626
var a = 6378245.0
var ee = 0.00669342162296594323
export default {
  data() {
    this.apiproto
    this.protobuf

    return {
      marker: marker, //
      lineArr: [],
      googlelineArr: [],
      tishiArr: [],
      graspRoad: null,
      dialogVisible: false,
      titleList: [],
      listLoading: false,
      dataLoading: false,
      listQuery: {},
      datatable: [],
      map: null,
      center: { lat: 22.5718025, lng: 114.0594166 },
      googleMap: null,
      mapShow: true,
      iconCharging: iconCharging,
      iconyhub: iconyhub,
      iconwarr: iconwarr,
      iconoffline: iconoffline,
      deviceName: this.$route.query.deviceName,
      mcuId: this.$route.query.mcuId,
      googleMapStyles: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        }
      ],
      isDisabeldSearchBtn: false,
      initMapTimer: null,
      yellowIcon: null,
      greenIcon: null,
      tianMapLoadFinished: false,
      pathArr: [],
      pathList: [],
      positionMarker: null,
      loading: true,
      CarTrack: null, // 轨迹
      carLnglat: null // 轨迹：小车经过时的坐标
    }
  },
  created() {
    this.listQuery = {
      startTime: this.$route.query.startTime,
      endTime: this.$route.query.endTime
    }
    this.mapShow = this.$store.state.map == 'gdMap'
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    if (this.$store.state.map == 'gdMap') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.loadTiandi()
        }, 1000)
      })
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.initGoogleMap()
        }, 1000)
      })
    }
    this.titleList[0] = {
      deviceName: this.$route.query.deviceName,
      mcuId: this.$route.query.mcuId,
      startTime: this.$route.query.startTime,
      endTime: this.$route.query.endTime
    }
  },
  methods: {
    loadTiandi() { // 加载--天地图
      loadTiandiJs().then(res => {
        console.log('天地图加载成功31')
        this.initTianMap()
        clearInterval(this.initMapTimer)
        this.tianMapLoadFinished = this.loading = true
      }).catch(() => {
        console.log('天地图加载失败32')
        this.tianMapLoadFinished = this.loading = false
        this.initMapTimer = setInterval(() => {
          this.loadTiandi()
        }, 3000)
      })
    },
    initTianMap() { // 初始化--天地图
      this.map = ''
      // 初始化地图对象
      this.map = new T.Map('map-container')
      // 设置显示地图的中心点和级别
      this.map.centerAndZoom(tianMapLngLat(114.068842, 22.655542), 10)
      // console.log('theme',this.theme)
      this.yellowIcon = new T.Icon({
        iconUrl: require('@/assets/icon/yellow.png'), // "http://api.tianditu.gov.cn/img/map/markerA.png",
        iconSize: new T.Point(20, 20),
        iconAnchor: new T.Point(10, 25)
      })
      this.greenIcon = new T.Icon({
        iconUrl: require('@/assets/icon/green.png'), // "http://api.tianditu.gov.cn/img/map/markerA.png",
        iconSize: new T.Point(20, 20),
        iconAnchor: new T.Point(10, 25)
      })
      this._listLocationData() // 获取轨迹数据
    },
    _listLocationData() { // 获取轨迹数据--天地图
      this.loading = true
      if (!this.listQuery.startTime || !this.listQuery.endTime) return

      // 清空
      this.positionMarker = null
      this.pathArr = []
      this.pathList = []

      listLocationData({
        // endDate: '1624343758000',
        // gpsOnly: 1,
        // mcuId: '001d00115847501420303142',
        // startDate: '1624257358000'
        endDate: this.listQuery.endTime,
        gpsOnly: 1,
        mcuId: this.mcuId,
        startDate: this.listQuery.startTime
      }).then(res => {
        const buf = protobuf.util.newBuffer(res)
        const ress = GNSSProto.decode(buf)
        this.loading = false
        if (ress.resultCode == 1001 && ress.gnssTrace && ress.gnssTrace.trace) {
          const list = ress.gnssTrace.trace
          console.log('_listLocationData:list', list)
          if (!list.length) return
          for (var i = list.length - 1; i >= 0; i--) {
            var data = list[i]
            if (i > 0) {
              var data2 = list[i - 1]
              const lat1 = data.gpsLocationLat || data.gnssLat
              const lng1 = data.gpsLocationLong || data.gnssLong
              const lat2 = data2.gpsLocationLat || data2.gnssLat
              const lng2 = data2.gpsLocationLong || data2.gnssLong
              if (this.getDistance(lat1, lng1, lat2, lng2) < 0.05 || this.getDistance(lat1, lng1, lat2, lng2) > 100) {
                continue
              }
            }
            this.pathList.push(data)
            this.datatable.push(data)
          }
          this.pathList.forEach(element => {
            if (element.gnssLong != 999 && element.gpsLocationLong != 999) {
              const lat = element.gpsLocationLat || element.gnssLat
              const lng = element.gpsLocationLong || element.gnssLong
              this.pathArr.push([lng, lat])
            }
          })
          console.log('_listLocationData:pathList', this.pathList)
          this.initLocus()
        } else {
          this.pathArr = []
          this.map.centerAndZoom(tianMapLngLat(0, 0), 2)
          this.$message(i18n.t('yhubReport.Nodata'))
        }
      })
    },
    showLine(lnglats) { // 连线部分 轨迹--天地图
      var line
      var points = []
      for (var i = 0; i < lnglats.length; i = i + 1) {
        points.push(tianMapLngLat(lnglats[i][0], lnglats[i][1]))
      }
      line = new T.Polyline(points, {
        strokeColor: '#039be5e6',
        color: '#039be5e6',
        strokeWeight: 1,
        strokeOpacity: 1
      })
      this.map.addOverLay(line)
    },
    initLocus() { // 轨迹--天地图
      if (this.CarTrack) {
        if (this.map) this.map.clearOverLays()
        if (this.CarTrack.carMarker) this.map.removeOverLay(this.CarTrack.carMarker)
        if (this.CarTrack.D3OverLayer) this.map.removeOverLay(this.CarTrack.D3OverLayer)
      }
      this.showLine(this.pathArr)
      this.CarTrack = new T.CarTrack(this.map, {
        interval: 1,
        speed: 1,
        dynamicLine: true,
        polylinestyle: { color: '#039be5', weight: 5, opacity: 0.9 },
        Datas: this.pathArr.map(function(obj, i) {
          var coordinates = obj
          var lnlat = tianMapLngLat(coordinates[0], coordinates[1])
          return lnlat
        }),
        carstyle: { display: true, iconUrl: 'http://lbs.tianditu.gov.cn/images/openlibrary/car.png', width: 41, height: 20 },
        passOneNode: (val) => {
          this.carLnglat = val
        }
      })
      if (this.pathArr.length > 0) this.map.centerAndZoom(tianMapLngLat(this.pathArr[0][0], this.pathArr[0][1]), 15)
      this.loading = false
    },
    startAnimation(val) {
      if (this.mapShow) {
        this.CarTrack.start()
      } else {
        this.stopAnimation('stop')
        hadClickBtn = val
        window.clearInterval(timer)
        timer = null
        if (line) line.setMap(null)
        line = null
        var that = this
        // that.googleMap.clearMap()
        // 动画开始
        var lineSymbol = {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 4,
          strokeColor: '#0C1EE8'
        }

        line = new google.maps.Polyline({
          path: that.googlelineArr,
          icons: [
            {
              icon: lineSymbol,
              offset: '100%'
            }
          ],
          strokeColor: '#AAB7B8', // 线条颜色
          // strokeOpacity: 0.8, // 线条透明度
          // strokeWeight: 6, // 线条粗细
          map: that.googleMap
        })
        // animateCircle()
        // function animateCircle() {
        count = 0
        timer = window.setInterval(function() {
          count = (count + 1) % 200
          hadCount = count
          var icons = line.get('icons')
          icons[0].offset = count / 2 + '%'
          // iconsOffset = icons[0].offset
          line.set('icons', icons)
        }, 200)
        // }
      }
    },
    pauseAnimation(val) {
      if (this.mapShow) {
        this.CarTrack.pause()
      } else {
        if (hadClickBtn == val) return // 避免连续重复点击
        hadClickBtn = val
        hadCount = count
        window.clearInterval(timer)
      }
    },
    resumeAnimation(val) {
      if (this.mapShow) {
        this.CarTrack.start()
      } else {
        if (hadClickBtn == val) return // 避免连续重复点击
        hadClickBtn = val
        count = hadCount
        timer = window.setInterval(function() {
          count = (count + 1) % 200
          var icons = line.get('icons')
          icons[0].offset = count / 2 + '%'
          // iconsOffset = icons[0].offset
          line.set('icons', icons)
        }, 200)
      }
    },
    stopAnimation(val) {
      if (this.mapShow) {
        this.CarTrack.stop()
      } else {
        if (hadClickBtn == val) return // 避免连续重复点击
        hadClickBtn = val
        count = hadCount = 0
        window.clearInterval(timer)
      }
    },
    queryData() { // 获取轨迹数据--谷歌地图
      var parmas = {
        mcuId: this.$route.query.mcuId,
        startDate: this.listQuery.startTime,
        endDate: this.listQuery.endTime,
        // endDate: '1624343758000',
        // mcuId: '001d00115847501420303142',
        // startDate: '1624257358000',
        gpsOnly: 1
      }
      this.lineArr = []
      this.googlelineArr = []
      this.datatable = []
      this.isDisabeldSearchBtn = true
      setTimeout(() => {
        this.isDisabeldSearchBtn = false
      }, 1000)
      this.loading = true
      listLocationData(parmas).then(res => {
        this.loading = false
        var gnssProto
        const buf = protobuf.util.newBuffer(res)
        gnssProto = GNSSProto.decode(buf)
        if (gnssProto.gnssTrace != null && gnssProto.gnssTrace.trace != null) {
          traceList = gnssProto.gnssTrace.trace
          // console.log('traceList', traceList)
          for (var i = traceList.length - 1; i >= 0; i--) {
            var data = traceList[i]
            if (i > 0) {
              var data2 = traceList[i - 1]
              const lat1 = data.gpsLocationLat || data.gnssLat
              const lng1 = data.gpsLocationLong || data.gnssLong
              const lat2 = data2.gpsLocationLat || data2.gnssLat
              const lng2 = data2.gpsLocationLong || data2.gnssLong
              if (this.getDistance(lat1, lng1, lat2, lng2) < 0.05 || this.getDistance(lat1, lng1, lat2, lng2) > 100) {
                continue
              }
            }
            this.datatable.push(data)

            const lat = data.gpsLocationLat || data.gnssLat
            const lng = data.gpsLocationLong || data.gnssLong
            if (this.mapShow) {
              this.lineArr.push([lng, lat])
            } else {
              if (this.gcj02towgs84(lng, lat)) {
                this.googlelineArr.push(this.gcj02towgs84(lng, lat))
              }
            }
          }
          this.googleMap.setZoom(16)
          console.log('this.datatable', this.datatable)
          if (this.datatable.length == 0) { this.dialogVisible = true } else { this.dialogVisible = false }
          this.googleLine()// 谷歌轨迹
        } else {
          this.dialogVisible = true
          this.googleMap.setZoom(2)
          this.googleMap.setCenter(this.gcj02towgs84(0, 0) || this.center)
          this.$message(i18n.t('yhubReport.Nodata'))
          return
        }
      })
    },
    init() { // 搜索
      if (this.$store.state.map == 'gdMap') {
        this._listLocationData() // 获取轨迹数据
      } else {
        this.initGoogleMap()
      }
    },
    initGoogleMap() { // 谷歌地图初始化
      var that = this
      this.loading = true
      this.googleMap = new google.maps.Map(
        document.getElementById('gmap-container'),
        {
          zoom: 16,
          // center: that.googlelineArr[0],
          center: that.googlelineArr[0] || that.center, // 避免googlelineArr为空时地图不出现
          mapTypeId: 'roadmap',
          styles: that.googleMapStyles,
          mapTypeControl: false, // 去掉卫星地图
          draggable: true, // 是否可拖动
          editable: true // 是否可编辑
        }
      )
      this.queryData()
    },
    googleLine() { // 谷歌轨迹
      this.googleMap.setCenter(this.googlelineArr[0] || this.center)
      if (this.googlelineArr.length) {
        var that = this
        var trackPath = new google.maps.Polyline({
          path: that.googlelineArr,
          strokeColor: '#039BE5', // 线条颜色
          strokeOpacity: 0.8, // 线条透明度
          strokeWeight: 3, // 线条粗细
          map: this.googleMap
        })

        // trackPath.setMap()
      }
    },
    // 计算两个坐标的位置/距离（单位km）
    getDistance(lat1, lng1, lat2, lng2) {
      var radLat1 = (lat1 * Math.PI) / 180.0
      var radLat2 = (lat2 * Math.PI) / 180.0
      var a = radLat1 - radLat2
      var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
      s = s * 6378.137 // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000
      return s
    },
    gcj02towgs84(lng, lat) {
      var lat = +lat
      var lng = +lng
      if (this.out_of_china(lng, lat)) {
        // return [lng, lat]
        return new google.maps.LatLng(lat, lng)
      } else {
        var dlat = this.transformlat(lng - 105.0, lat - 35.0)
        var dlng = this.transformlng(lng - 105.0, lat - 35.0)
        var radlat = (lat / 180.0) * PI
        var magic = Math.sin(radlat)
        magic = 1 - ee * magic * magic
        var sqrtmagic = Math.sqrt(magic)
        dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
        dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
        var mglat = lat + dlat
        var mglng = lng + dlng
        // return [lng * 2 - mglng, lat * 2 - mglat]
        return new google.maps.LatLng(lat * 2 - mglat, lng * 2 - mglng)
      }
    },

    transformlat(lng, lat) {
      var lat = +lat
      var lng = +lng
      var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
      ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0
      ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0
      ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0
      return ret
    },
    transformlng(lng, lat) {
      var lat = +lat
      var lng = +lng
      var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
      ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0
      ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0
      ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0
      return ret
    },
    out_of_china(lng, lat) {
      var lat = +lat
      var lng = +lng
      // 纬度3.86~53.55,经度73.66~135.05
      return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#map-container {
  width: calc(100% - 10px);
  height: 590px;
  margin:5px;
  position: relative;
}

#gmap-container {
  width: 100%;
  height: 620px;
}
.haveLocationInfo{
  height:600px;
  text-align: center;
  padding-top: 280px;
  width: 100%;
  position: absolute;
  z-index: 2;
  background: rgba(0,0,0,0.5);
}
.haveLocationP {
  background: #fff;
  padding: 20px 40px;
  color: black;
  display: inline-block;
}
</style>
